import { render, staticRenderFns } from "./AdminRuntimeLog.vue?vue&type=template&id=a25c9bc6"
import script from "./AdminRuntimeLog.vue?vue&type=script&lang=js"
export * from "./AdminRuntimeLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports